import configuracaoSistema from './configuracao-sistema'
import envioSms from './envio-sms'
import papel from './papel'
import permissaoAcesso from './permissao-acesso'

export default [
    {
        meta: {authenticated: true, layout: 'admin'},
        path: '/administracao',
        component: () => import('@/views/administracao/Index'),
        children: [
            ...configuracaoSistema,
            ...envioSms,
            ...papel,
            ...permissaoAcesso,
        ],
    },
]